<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="rows"
            item-value="customerId"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { map } from 'lodash'
import Moment from 'moment-timezone'

export default {
  name: 'VehicleCountReport',
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  computed: {
    headers() {
      const dateRange = this.generateDateRange(
        this.report.parameters.startDate,
        this.report.parameters.endDate
      )
      return [
        { text: this.$tc('customer', 1), value: 'customerName' },
        ...dateRange.map(date => ({
          text: Moment(date).format('MM/DD'), // Shorter date format
          value: date
        }))
      ]
    },
    rows () {
      const dateRange = this.generateDateRange(
        this.report.parameters.startDate,
        this.report.parameters.endDate
      )
      return Object.entries(this.report.results).map(([customerName, metrics]) => {
        const row = { customerName } // Use the customer name directly
        dateRange.forEach(date => {
          // Ensure date format matches the keys in metrics
          const formattedDate = `${date} 00:00:00` // Adjust if needed
          row[date] = metrics[formattedDate] ? parseInt(metrics[formattedDate], 10) : 0
        })
        return row
      })
    }
  },
  methods: {
    generateDateRange (startDate, endDate) {
      const dates = []
      // parseZone keeps the offset the report was generated with. Parsing in the browser's timezone instead would
      // shift the columns off the selected range, and off the date keys the back end returned in `results`.
      let currentDate = Moment.parseZone(startDate)
      const end = Moment.parseZone(endDate)
      while (currentDate.isSameOrBefore(end)) {
        dates.push(currentDate.format('YYYY-MM-DD'))
        currentDate = currentDate.add(1, 'day')
      }
      return dates
    },
    exportToCsv() {
      const csvContent = [
        this.headers.map(header => header.text).join(','),
        ...this.rows.map(row =>
          this.headers.map(header => row[header.value] || '').join(',')
        )
      ].join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', 'vehicle_count_report.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.table-container th {
  writing-mode: vertical-rl; /* Rotate text vertically */
  transform: rotate(180deg); /* Adjust orientation */
  text-align: center;
  white-space: nowrap;
}
</style>
